export default "__VITE_PUBLIC_ASSET__fe1bb5c7__"